import { ISOTimeTo12HourTime } from '@shared/utils/time';
import { RestaurantEvent } from '@shared/types/restaurants';

export function formatTime(restaurantEvent: RestaurantEvent): string {
  return `${ISOTimeTo12HourTime(restaurantEvent.shift.startTime)} - ${ISOTimeTo12HourTime(restaurantEvent.shift.endTime)}`;
}
